var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMenu = function SvgMenu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#9E9E9E",
    d: "M4 5.519A.51.51 0 0 1 4.5 5h15c.276 0 .5.232.5.519v.518a.51.51 0 0 1-.5.519h-15a.51.51 0 0 1-.5-.519zM4 11.74a.51.51 0 0 1 .5-.518h15c.276 0 .5.232.5.519v.518a.51.51 0 0 1-.5.519h-15a.51.51 0 0 1-.5-.519zM4 17.963a.51.51 0 0 1 .5-.519h15c.276 0 .5.233.5.519v.518a.51.51 0 0 1-.5.519h-15a.51.51 0 0 1-.5-.518z"
  })));
};
export default SvgMenu;